


















































































import Component from 'vue-class-component';
import { MasterPage } from '@/components/base/master/master-page';
import commonLogsApi from '@/api/common-logs.api';
import CommonLogsCriteriaComponent from '@/containers/account/common-logs/common-logs-criteria.vue';
import {ICommonLogsListModel, IGetCommonLogsModel, IPaging, ISort} from '@/entities';
import {mapGetters} from 'vuex';
import * as types from '@/store/types';


@Component({
    components: {
        'common-logs-criteria': CommonLogsCriteriaComponent
    },
    computed: mapGetters({
        superadminPermissions: types.AUTH_HAS_SUPERADMIN_PERMISSIONS,
        hasPermissionShowCommonLogs: types.AUTH_HAS_PERMISSION_SHOW_COMMON_LOGS
    })
})
export default class CommonLogsMasterPage extends MasterPage {
    public items: ICommonLogsListModel[] = [];

    protected defaultSort: ISort = {
        field: 'date',
        asc: false
    };

    private getModel: IGetCommonLogsModel = null;

    public modelChange(model: IGetCommonLogsModel) {
        this.getModel = model;
        this.search();
    }

    public download() {
        let body: IGetCommonLogsModel = {
            ...this.getModel,
            ...this.pageSortParams()
        };

        this.loading = true;
        return commonLogsApi
            .export(body)
            .then((response) => {
                const blob = new Blob([response], { type: 'application/txt' });
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = 'export_data_' +  (new Date().getTime()) + '.txt';
                link.click();
                URL.revokeObjectURL(link.href);
            })
            .catch((err) => console.warn(err));
    }

    // todo: refactor -> remove dublication
    protected search() {
        let body: IGetCommonLogsModel = {
            ...this.getModel,
             ...this.pageSortParams()
        };

        this.loading = true;
        return commonLogsApi
            .list(body)
            .then((response: IPaging<any>) => {
                this.loading = false;
                this.items = response.items;
                if (response.total !== null) {
                    this.total = response.total;
                }
            })
            .catch((err) => console.warn(err));
    }


}
